// =====================================
// NO EDITAR ESTE ARCHIVO DIRECTO
// COMPILADO 2026-08-03 12:46:29
// =====================================

enum EVENTS{
	_ID = 1,
	VIEW_EVENTS = 1000,		// Ver eventos
	CREATE_EVENT = 1001,		// Crear eventos
	PUBLISH_EVENT = 1002,		// Publicar eventos
	EDIT_EVENT_GENERAL = 1020,		// Editar general
	EDIT_SINOPSIS = 1021,		// Editar sinopsis
	EDIT_POSTER = 1022,		// Cambiar poster
	EDIT_USER_ASSIGNED = 1023,		// Asignar responsable
	EDIT_EXCLUSIVE_BANK = 1024,		// Editar Banco
	EDIT_SUBDOMAIN = 1100,		// Editar subdominio
	EDIT_OPTIONS = 1101,		// Editar opciones
	EDIT_OPTIONS_MSI = 1102,		// Editar opcion: MSI
	VIEW_EVENT_CODES = 1120,		// Ver códigos de acceso
	CREATE_EVENT_CODES = 1121,		// Crear códigos de acceso
	VIEW_BALANCE = 1300,		// Ver estado de cuenta de evento
	CREATE_PAYOUT = 1301,		// Crear liquidación de evento
	CREATE_COMPLETED_PAYOUT = 1302,		// Crear liquidación completada
	VIEW_EVENT_GROUP = 1400,		// Ver eventos padre
	CREATE_EVENT_GROUP = 1401,		// Crear eventos padre
	EDIT_EVENT_GROUP = 1402,		// Editar eventos padre
	EDIT_EVENT_GROUP_POSTER = 1403,		// Editar poster eventos padre
	PUBLISH_EVENT_GROUP = 1404,		// Publicar eventos padre
	DELETE_EVENT_GROUP = 1499,		// Eliminar eventos padre
	DELETE_EVENT = 1900,		// Eliminiar evento
	DELETE_PARENT = 1901,		// Eliminiar evento padre
}
enum DATES{
	_ID = 2,
	VIEW_DATE = 2000,		// Ver calendarios
	CREATE_DATE = 2001,		// Crear calendario
	MULTIPLY_DATE = 2002,		// Multiplicar calendario
	CHANGE_DATE = 2100,		// Cambiar fecha
	CHANGE_STATUS = 2101,		// Cambiar estatus
	CHANGE_VENUE = 2102,		// Cambiar recinto
	CHANGE_START_END_DATES = 2103,		// Editar fechas inicio fin
	EDIT_SECTIONS = 2200,		// Editar secciones
	EDIT_SECTION_TICKET_COUNT = 2201,		// Editar aforo sección
	EDIT_PRICES = 2250,		// Editar precios
	REMOVE_DATE_SECTION = 2290,		// Eliminar sección
	EDIT_PAYMENT_METHODS = 2300,		// Editar formas de pago
	EDIT_DELIVERY_METHODS = 2310,		// Editar formas de entrega
	REQUEST_REFUNDABLE = 2350,		// Solicitar calendario reembolsable
	REQUEST_REFUNDABLE_COMPLETE = 2351,		// Solicitar calendario reembolsable COMPLETO
	SET_REFUNDABLE = 2355,		// Marcar calendario reembolsable
	SET_REFUNDABLE_COMPLETE = 2356,		// Marcar calendario reembolsable COMPLETO
	RECEIVE_REFUNDABLE_EMAIL = 2357,		// Recibir correos de solicitud reembolsable
	VIEW_EVENT_FORM = 2400,		// Ver formulario
	EDIT_EVENT_FORM = 2401,		// Editar formulario
	DELETE_EVENT_FORM = 2440,		// Eliminar formulario
	ADD_QUEUE = 2450,		// Agregar fila de espera
	REMOVE_QUEUE = 2451,		// Quitar fila de espera
	CHANGE_DATE_SEAT_STATUS = 2500,		// Cambiar estado butacas
	ADD_SECTION_HOLD = 2501,		// Bloquear boletos general
	DELETE_SECTION_HOLD = 2502,		// Eliminar bloqueo general
	DELETE_DATE = 2900,		// Eliminar calendarios
}
enum ORDERS{
	_ID = 3,
	VIEW_ORDERS = 3000,		// Ver ordenes
	VIEW_TICKETS = 3001,		// Ver boletos
	VIEW_PDF = 3002,		// Ver PDF boletos
	VIEW_ORDER_EMAILS = 3003,		// Ver correos de orden
	VIEW_TICKET_USES = 3004,		// Ver usos boleto
	VIEW_PAYMENTS = 3005,		// Ver pagos
	VIEW_TICKET_FORM = 3006,		// Ver formulario
	VIEW_RECEIPT = 3007,		// Ver recibo
	ORDER_CREATOR = 3080,		// Crear orden
	CREATE_PRINTED_TICKET = 3081,		// Crear boletoso duros
	RESEND_EMAIL = 3100,		// Reenviar correos
	SET_TICKET_PAID = 3102,		// Marcar boleto pagado
	CREATE_FREE = 3103,		// Crear cortesias
	MANUAL_DEPOSIT = 3104,		// Conciliación manual
	MOVE_TICKETS = 3105,		// Mover boletos
	EXTEND_EXPIRATION = 3106,		// Extender expiración
	MASSIVE_RESEND_EMAILS = 3107,		// Reenvio masivo de boletos
	CHANGE_ORDER_DATA = 3200,		// Cambiar datos
	CHANGE_ORDER_EMAIL = 3201,		// Cambiar correo
	CHANGE_TOTALS = 3202,		// Cambiar totales
	CHANGE_DELIVERY_METHOD = 3204,		// Cambiar forma de entrega
	EDIT_FORM = 3205,		// Editar formulario
	EDIT_TICKET_PRICE = 3206,		// Editar precio boleto
	CHANGE_TICKET_SEAT = 3207,		// Reasignar butaca de boleto
	EDIT_PAYMENT_AMOUNTS = 3208,		// Editar cantidades de pago
	VIEW_REFUND = 3300,		// Ver reembolso
	CREATE_REFUND = 3301,		// Reembolsar
	REFUND_COMPLETE = 3302,		// Reembolsar completo
	CREATE_FAKE_REFUND = 3303,		// Marcar orden reembolsada
	CREATE_REFUND_REQUEST = 3304,		// Crear solicitud de reembolso
	VIEW_REFUND_REQUEST = 3305,		// Ver solicitud de reembolso
	RESEND_REFUND_REQUEST = 3306,		// Reenviar solicitud de reembolso
	SET_REFUND_COMPLETED = 3320,		// Completar reembolso
	REVERT_REFUND_COMPLETE = 3321,		// Regresar reembolso completado
	REQUEST_REFUND_INFO = 3322,		// Solicitar info de reembolso
	EXECUTE_REFUND = 3323,		// Ejecutar reembolso
	UPLOAD_REFUND_FILE = 3380,		// Subir evidencia reembolso
	DELETE_REFUND_FILE = 3381,		// Eliminar evidencia reembolso
	SET_REFUND_CANCELLED = 3390,		// Cancelar reembolso
	USE_TICKET = 3400,		// Usar boleto
	DELETE_TICKET_USE = 3401,		// Eliminar uso boleto
	VIEW_HIDDEN_ORDERS = 3880,		// Ver ordenes escondidas
	HIDE_ORDERS = 3881,		// Esconder ordenes
	CANCEL_TICKET = 3900,		// Cancelar boleto
	CANCEL_PAYMENT = 3901,		// Cancelar pago
	REVIVE_TICKET = 3902,		// Revivir boleto
	CANCEL_UNUSED = 3903,		// Cancelar boletos no usados
	CANCEL_TICKET_PRINT = 3905,		// Cancelar impresiones
}
enum VENUES{
	_ID = 4,
	VIEW_VENUES = 4000,		// Ver recintos
	CREATE_VENUE = 4001,		// Crear recinto
	EDIT_VENUE = 4002,		// Editar recinto
	CREATE_SECTION = 4050,		// Crear secciones
	EDIT_SECTION = 4051,		// Editar secciones
	EDIT_VENUE_SEATS = 4052,		// Editar mapa butacas
	DELETE_VENUE = 4900,		// Eliminar recinto
	DELETE_SECTION = 4901,		// Eliminar sección
}
enum PDV{
	_ID = 5,
	VIEW_PDV = 5000,		// Ver puntos de venta
	CREATE_PDV = 5001,		// Crear punto de venta
	EDIT_PDV = 5002,		// Editar punto de venta
	DISABLE_COMMISSION = 5003,		// Desactivar comisión
	EDIT_PAYMENT_METHODS = 5004,		// Editar formas de pago
	VIEW_PDV_ACCESS = 5020,		// Ver accesos a pdv
	VIEW_PDV_TOKEN = 5021,		// Ver tokens de registro
	VIEW_PDV_CORTES = 5100,		// Ver cortes PDV
	EDIT_PDV_ZONE = 5200,		// Editar zonas de PDV
	EDIT_PDV_EVENTS = 5201,		// Editar eventos de PDV
	DEACTIVE_PDV = 5900,		// Desactivar PDV
	RESET_PDV = 5901,		// Desenlazar PDV
}
enum CATALOGS{
	_ID = 6,
	DELIVERY_METHODS_VIEW = 30000,		// Formas Envio: Ver
	DELIVERY_METHODS_CREATE = 30001,		// Formas Envio: Crear
	DELIVERY_METHODS_EDIT = 30002,		// Formas Envio: Editar
	DELIVERY_METHODS_DELETE = 30039,		// Formas Envio: Eliminar
	CAROUSEL_VIEW = 30040,		// Carrusel: Ver
	CAROUSEL_CRAETE = 30041,		// Carrusel: Crear
	CAROUSEL_EDIT = 30042,		// Carrusel: Editar
	CAROUSEL_DELETE = 30059,		// Carrusel: Eliminar
	BANK_VIEW = 30060,		// Bancos: Ver
	BANK_CREATE = 30061,		// Bancos: Crear
	BANK_EDIT = 30062,		// Bancos: Editar
	BANK_BIN_EDIT = 30063,		// Bancos: Editar BINs
	BANK_DELETE = 30090,		// Bancos: Eliminar
	COUPONS_VIEW = 30100,		// Cupones: Ver
	COUPONS_CREATE = 30101,		// Cupones: Crear
	COUPONS_EDIT = 30102,		// Cupones: Editar
	COUPONS_DELETE = 30190,		// Cupones: Eliminar
	SCANNER_VIEW = 30200,		// Checadores: Ver
	SCANNER_CREATE = 30201,		// Checadores: Crear
	SCANNER_EDIT = 30202,		// Checadores: Editar
	SCANNER_REINITIALIZE = 30203,		// Checadores: Reinicializar
	SCANNER_REGEN_TOKEN = 30204,		// Checadores: Regenerar token
	SCANNER_DELETE = 30290,		// Checadores: Eliminar
	PROMOTER_VIEW = 30300,		// Promotores: Ver
	PROMOTER_CREATE = 30301,		// Promotores: Crear
	PROMOTER_EDIT = 30302,		// Promotores: Editar
	PROMOTER_EDIT_SERVICE = 30303,		// Promotores: Editar afiliación
	PROMOTER_ADD_CONTACT = 30320,		// Promotores: Agregar contacto
	PROMOTER_EDIT_CONTACT = 30321,		// Promotores: Editar contacto
	PROMOTER_DELETE_CONTACT = 30339,		// Promotores: Eliminiar contacto
	PROMOTER_ADD_BANK = 30340,		// Promotores: Agregar cuenta bancaria
	PROMOTER_DELETE_BANK = 30359,		// Promotores: Eliminar cuenta bancaria
	PROMOTER_DELETE = 30390,		// Promotores: Eliminiar
	ZONES_VIEW = 30400,		// Zonas: Ver
	ZONES_CREATE = 30401,		// Zonas: Crear
	ZONES_EDIT = 30402,		// Zonas: Editar
	ZONES_DELETE = 30440,		// Zonas: Eliminar
	TERMINALS_VIEW = 30500,		// Terminales: Ver
	TERMINALS_CREATE = 30501,		// Terminales: Crear
	TERMINALS_EDIT = 30502,		// Terminales: Editar
	TERMINALS_VIEW_TOKEN = 30504,		// Terminales: Ver tokens de registro
	TERMINALS_RESET = 30505,		// Terminales: Desenlazar
	TERMINALS_EDIT_CONFIG = 30506,		// Terminales: Editar configuración
	TERMINALS_DELETE = 30590,		// Terminales: Eliminar
}
enum USERS{
	_ID = 7,
	VIEW_USERS = 7001,		// Ver usuarios
	EDIT_USERS = 7002,		// Editar usuarios
	CREATE_USERS = 7003,		// Crear usuarios
	VIEW_USER_LOGINS = 7004,		// Ver logins
	CHANGE_PASSWORD = 7100,		// Cambiar contraseñas
	VIEW_PASSWORD_LINK = 7101,		// Ver link de contraseña
	EDIT_ACCESS = 7200,		// Editar permisos
	EDIT_REPORTS_ACCESS = 7201,		// Editar permisos empresarios
	GIVE_ADMIN_ACCESS = 7302,		// Dar acceso: Admin
	GIVE_OPERATIONS_ACCESS = 7303,		// Dar acceso: Operaciones
	GIVE_REPORTS_ACCESS = 7305,		// Dar acceso: Empresarios
	GIVE_PDV_ACCESS = 7320,		// Dar acceso: PDV
	GIVE_SCANNER_ACCESS = 7321,		// Dar acceso: Scanner
	DEACTIVATE_USER = 7900,		// Desactivar/reactivar usuarios
	REFRESH_USER = 7901,		// Reiniciar sesión
}
enum CONTABILIDAD{
	_ID = 8,
	ADD_DEPOSIT = 8000,		// Conciliar
	CANCEL_DEPOSIT = 8001,		// Eliminiar conciliacion
	FIX_DEPOSIT_AMOUNT = 8002,		// Arreglar cantidad depositada
	VIEW_DEPOSITS = 8003,		// Ver conciliación
	VIEW_PDV_DEPOSIT = 8100,		// Ver conciliación taquillas
	CREATE_PDV_DEPOSIT = 8101,		// Conciliar efectivo taquillas
	EDIT_PDV_DEPOSIT = 8102,		// Editar conciliación taquillas
	UPLOAD_EVIDENCE_PDV_DEPOSIT = 8103,		// Subir evidencia deposito taquilla
	DELETE_EVIDENCE_PDV_DEPOSIT = 8104,		// Eliminar evidencia deposito taquilla
	VERIFY_PDV_DEPOSIT = 8105,		// Verificar deposito
	EDIT_MONEY_SUPERVISE = 8106,		// Editar supervisión taquilla
	CANCEL_PDV_DEPOSIT = 8190,		// Eliminar deposito efectivo
	VIEW_DAY_TABLE = 8200,		// Ver tabla del día
	VIEW_PAPELETA = 8201,		// Ver papeleta
	VIEW_PAYOUTS = 8301,		// Ver liquidaciones
	APPROVE_PAYOUT = 8302,		// Aprobar liquidación
	APPROVE_AUTOMATIC_PAYOUT = 8303,		// Agendar liquidación automática
	SET_PAYOUT_COMPLETE = 8304,		// Marcar liquidación completada
	CREATE_RETURN_PAYOUT = 8305,		// Liquidar retorno excediente
	DOWNLOAD_STP_FILE = 8306,		// Descargar archivo STP
	UPLOAD_PAYOUT_FILE = 8307,		// Subir evidencia liquidación
	DELETE_PAYOUT_FILE = 8308,		// Eliminar evidencia liquidación
	CREATE_PAYOUT_GROUP = 8350,		// Crear grupo de liquidaciones
	APPROVE_PAYOUT_GROUP = 8351,		// Aprobar grupo de liquidaciones
	CANCEL_PAYOUT_GROUP = 8359,		// Cancelar grupo de liquidaciones
	CANCEL_PAYOUT = 8490,		// Cancelar liquidación
}
enum REPORTS_ADMIN{
	_ID = 9,
	ACCESS = 9100,		// Acceso a reportes
	INVOICE = 9101,		// Reporte de facturación
	DATE_EVENTS = 9102,		// Reporte de fecha de eventos
	PDV_SALES = 9103,		// Reporte de ventas en taquilla
	PDV_CORTES = 9104,		// Reporte de cortes de taquilla
	PDV_DEPOSITS = 9105,		// Reporte de depositos de taquilla
	AFORO = 9106,		// Reporte de aforo
	INCOME = 9107,		// Reporte de ingresos
	BUYERS = 9108,		// Reporte de compradores
	FAKE_SALES_REPORT = 9109,		// Reporte aforo falso
	EVENT_BALANCE = 9110,		// Reporte estado de cuenta
}
enum TOOLS{
	_ID = 10,
	TEMPLATES_VIEW = 10000,		// Templates: Ver
	TEMPLATES_EDIT = 10001,		// Templates: Editar template
	TEMPLATES_DELETE = 10002,		// Templates: Eliminar template
	QUEUES_EDIT = 10200,		// Filas: Modificar filas
}
enum SELLERS{
	_ID = 20,
	ACCESS_ALL_EVENTS = 20000,		// Acceso a todos los eventos
	REQUEST_EVENT_ACCESS = 20001,		// Solicitar accceso a evento
	SELL = 20100,		// Venta
	SELL_CASH = 20101,		// Venta efectivo
	SELL_RESTRICTED_PRICES = 20102,		// Venta precios restringidos
	SELL_FREE = 20103,		// Venta cortesías
	BLOCK_SEATS = 20104,		// Bloqueo de butacas
	CANCEL_ORDER = 20190,		// Cancelar venta
	EXPIRE_ANY_PDV_ORDER = 20200,		// Expirar orden cualquier PDV
	CANCEL_OTHER_PDV_ORDER = 20201,		// Cancelar orden otro PDV
	CANCEL_PAID_ORDER = 20202,		// Cancelar ordenes pagadas
	CANCEL_CORTE_ORDER = 20203,		// Cancelar orden corte cerrado
	PRINT = 20300,		// Imprimir ventas PDV
	PRINT_OTHER_PDV = 20301,		// Imprimir ventas otros PDV
	REPRINT = 20302,		// Reimpresión
	RESEND_TICKETS = 20303,		// Reenviar boletos
	VIEW_TICKET_PRINTS = 20304,		// Ver impresiones del boleto
	CANCEL_TICKET_PRINT = 20305,		// Cancelar impresion
	REFUND_TICKET_REQUEST = 20400,		// Reembolsar boletos solicitud
	REFUND_EXTRA_CHARGES = 20401,		// Reembolsar otros cargos
	REFUND_CORTE_ENDED = 20402,		// Reembolsar fuera de corte
	START_CORTE = 20500,		// Iniciar corte
	END_CORTE = 20501,		// Cerrar corte
	VIEW_CORTES_OTHER_PDV = 20502,		// Ver cortes otros pdv
	CANCEL_CORTE = 20519,		// Cancelar corte
}
enum CHECKERS{
	_ID = 21,
	LOGIN = 21000,		// Login checador
	SCAN_TICKET = 21001,		// Escanear boleto
	USE_TICKET = 21002,		// Usar boleto
	CANCEL_TICKET_USE = 21003,		// Cancelar uso boleto (5 min)
	CANCEL_TICKET_USE_ALWAYS = 21004,		// Cancelar uso boleto (siempre)
	SCANNER_WITHOUT_TOKEN = 21900,		// Checador sin token
}
enum REPORTS{
	_ID = 22,
	ACCESS_ALL_EVENTS = 22000,		// Acceso a todos eventos
}
enum ADMIN{
	_ID = 60,
	DEVELOPER = 65000,		// Desarrollador
	STATISTICS = 65001,		// Estadisticas
	VIEW_COMMISSIONS = 65002,		// Desglose comisiones
	DOCUMENTATION_ADMIN = 65003,		// Sistema documentación
	LOGGER_SITE = 65004,		// Sistema logs
	ANALYTICS = 65005,		// Analytics
}

export default {
	EVENTS,
	DATES,
	ORDERS,
	VENUES,
	PDV,
	CATALOGS,
	USERS,
	CONTABILIDAD,
	REPORTS_ADMIN,
	TOOLS,
	SELLERS,
	CHECKERS,
	REPORTS,
	ADMIN,
}